import React from 'react'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import Header from './header'
import i18n from '~/i18n'
import PostHogFunctions from '~/Classes/posthog'

export default function QuestionsStep3({ answers, setAnswers, errors, roles = [] }) {
    const selectRole = (e) => {
        PostHogFunctions.capture('onboarding-3-button-role')
        setAnswers({ ...answers, inviteRole: e.target.value })
    }
    return (
        <div>
            <Header
                header={i18n.t('account:questions.step3.header')}
                subheader={i18n.t('account:questions.step3.subheader')}
            />
            <div className='quickFlex' style={{ gap: 12 }}>
                <TextInput
                    outerStyle={{ width: 344 }}
                    label={i18n.t('account:questions.step3.email')}
                    placeholder={i18n.t('account:questions.step3.enterEmail')}
                    type='email'
                    name='inviteEmail'
                    value={answers.inviteEmail}
                    onChange={(e) => setAnswers({ ...answers, inviteEmail: e.target.value })}
                    error={errors.inviteEmail}
                />
                <Select
                    dataAttribute={{
                        ph: 'account-onboarding-3-button-role'
                    }}
                    outerstyle={{ flexGrow: 1, marginBottom: errors.inviteEmail ? 35 : 0 }}
                    label={i18n.t('account:questions.step3.role')}
                    data={roles}
                    value={answers.inviteRole}
                    name='inviteRole'
                    onChange={selectRole}
                    error={errors.inviteRole}
                />
            </div>
        </div>
    )
}
